import axios from 'axios';

import { GET_APPS, GET_FAVORITE_APPS, SYSTEM_TOAST_SUCCESS_MESSAGE } from './types';
import { serverEndPoint } from './Utils';

export const getApps = () => {
  return async (dispatch) => {
    const { data, status } = await axios.get(`${serverEndPoint}/apps/getApps`);
    if (status === 200) {
      dispatch({
        type: GET_APPS,
        payload: data,
      });
    }
    return data;
  };
};

export const getFavoriteApps = (cpf) => {
  return async (dispatch) => {
    const { data, status } = await axios.get(`${serverEndPoint}/apps/getFavoriteApps/${cpf}`);
    if (status === 200) {
      dispatch({
        type: GET_FAVORITE_APPS,
        payload: data,
      });
    }
    return data;
  };
};

export const addFavoriteApp = (params) => {
  return async (dispatch) => {
    const { data, status } = await axios.post(`${serverEndPoint}/user/setFavorite`, params);
    if (status === 200) {
      dispatch({
        type: SYSTEM_TOAST_SUCCESS_MESSAGE,
        payload: 'Aplicativo adicionado com sucesso!',
      });
    }
    return data;
  };
};

export const removeFavoriteApp = (params) => {
  return async (dispatch) => {
    const { data, status } = await axios.post(`${serverEndPoint}/user/removeFavorite`, params);
    if (status === 200) {
      dispatch({
        type: SYSTEM_TOAST_SUCCESS_MESSAGE,
        payload: 'Aplicativo removido com sucesso!',
      });
    }
    return data;
  };
};
